export default "/accountant.4dc016546f11018f8421e7db1283a7d5.png";